import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CategoryDto, CategoryResponse } from '../../models/category-response';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + "/api/v2";
  }
  constructor(private http: HttpClient) { }

  getMainCategories(): Observable<CategoryResponse> {
    return this.http.get<CategoryResponse>(`${this.apiUrl}/mainCategories`);
  }
  // getSubCategories(main : number): Observable<CategoryResponse> {
  //   return this.http.get<CategoryResponse>(`${this.apiUrl}/SubCategories/${main}`);
  // }
  //   getSubCategories(
  //   parentId: number,
  //   page: number = 1,
  //   perPage: number = 10,
  //   search: string = '',
  //   lang : string = "eg"
  // ) {
  getSubCategories(search: string = '', page: number = 1, perPage: number = 10) {
    // let url = `${this.apiUrl}/Categories/${parentId}?page=${page}&perPage=${perPage}&lang=${lang}`;
    let url = `${this.apiUrl}/Categories/all?page=${page}&pageSize=${perPage}`;

    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    return this.http.get<any>(url);
  }
  getCategoryBySlug(slug: string): Observable<CategoryDto> {
    return this.http.get<CategoryDto>(`${this.apiUrl}/SubCategories/slug/${slug}`);
  }

  getCategoryById(Id: number): Observable<CategoryDto> {
    return this.http.get<CategoryDto>(`${this.apiUrl}/SubCategories/id/${Id}`);
  }

  deleteCategoryBySlug(slug: string): Observable<CategoryDto> {
    return this.http.delete<CategoryDto>(`${this.apiUrl}/SubCategories/slug/${slug}/permanent`);
  }
  deleteCategoryById(Id: number): Observable<CategoryDto> {
    return this.http.delete<CategoryDto>(`${this.apiUrl}/SubCategories/id/${Id}/permanent`);
  }
  createCategory(form: any): Observable<CategoryResponse> {
    const formData = new FormData();

    Object.keys(form).forEach(key => {
      const value = form[key];
      if (value !== null && value !== undefined) {
        if (value instanceof File) {
          formData.append(key, value, value.name);
        } else {
          formData.append(key, value.toString());
        }
      }
    });

    // 🔍 للتأكد أثناء التجربة
    formData.forEach(element => {
      console.log(element);
    })



    return this.http.post<CategoryResponse>(
      `${this.apiUrl}/SubCategories`,
      formData
    );
  }

  editCategory(slug: string, form: any): Observable<CategoryResponse> {
    const formData = new FormData();

    Object.keys(form).forEach(key => {
      const value = form[key];
      if (value !== null && value !== undefined) {
        if (value instanceof File) {
          formData.append(key, value, value.name);
        } else {
          formData.append(key, value.toString());
        }
      }
    });

    // 🔍 للتأكد أثناء التجربة
    formData.forEach(element => {
      console.log(element);
    })



    return this.http.put<CategoryResponse>(
      `${this.apiUrl}/SubCategories/update/${slug}`,
      formData
    );
  }


  updateCategoryFlags(slug: string, data: {
    status?: boolean;
    featured?: boolean;
    top?: boolean;
  }) {
    return this.http.put(`${this.apiUrl}/categories/slug/${slug}/flags`, data);
  }

}
